/* This file was automatically generated - please modify the template not this file! */

import { createSelector } from "reselect";

import { TextSnippet, AppState } from "./model";

export const routeIdSelector = (state: AppState) => {
    return state.router.params.textSnippetId;
};

export type SelectorState = AppState;

export const textSnippetsSelector = (state: AppState) => state.textSnippets;

export const textSnippetSelector = createSelector(
    textSnippetsSelector,
    routeIdSelector,
    (textSnippets: TextSnippet[], id: any) => {
        return textSnippets.filter(c => c.id === id)[0] || {} as TextSnippet;
    }
);

export const basePathSelector = (state: AppState) =>
    state.router.pathname.substring(0, state.router.pathname.indexOf("textSnippets") + "textSnippets".length);
